import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    {title: 'Código'},
    {title: 'Nombre'}
];

class ImpuestoPartnerModal extends Component {
    componentDidMount(): void {
        this.closeAction();
    }


    closeImpuesto = async () => {
        $('#taxesPartnerModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#taxesPartnerModal').on('hidden.bs.modal', () => {
            //console.log("Close Impuesto");
            cleanData();
        });
    };

    render() {
        const {data, selectTaxe} = this.props;
        //console.log("data Taxes", data);
        if(data.length === 0){
            return <div className="modal fade bd-example-modal-lg bgtransparent" role="dialog"  id="taxesPartnerModal"></div>;
        }
        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll"  role="dialog"  id="taxesPartnerModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Impuesto</h4>
                                <button type="button" className="close" onClick={this.closeImpuesto} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="table-responsive">
                                                <table className="table response" style={{marginBottom: 0}}>
                                                    <tbody>
                                                    <DataTablesCreate data={data} headers={headers} view={"taxesModal"} action={selectTaxe}/>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeImpuesto}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ImpuestoPartnerModal;